import {Reducer} from 'redux'
import {TenantActionTypes, TenantState} from './types';
import TenantService from "../../services/TenantService";

// Type-safe initialState!
const initialState: TenantState = {
	tenant: null
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<TenantState> = (state = initialState, action) => {
	switch (action.type) {
		case TenantActionTypes.FETCH_ONE_REQUEST: {
			let tabId = action.payload
			TenantService.getOne(tabId)
			return state
		}
		case TenantActionTypes.FETCH_ONE_COMPLETED: {
			return { ...state, tenant: action.payload}
		}
		case TenantActionTypes.SAVE_REQUEST: {
			TenantService.save(action.payload)
			return state
		}
		case TenantActionTypes.SAVE_COMPLETED: {
			return { ...state, tenant: action.payload}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as TenantReducer}
